<template lang="html">
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="6">
          <h6 class="m-0">Dados cadastrais</h6>
        </d-col>
        <d-col cols="12" lg="6" class="text-right d-flex justify-content-end" v-if="model">
          <commercial-buttons :commercial="model" v-if="isAdmin"></commercial-buttons>
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form @submit.prevent="save" :validated="hasErrors">
              <d-row>
                <d-col md="6" class="form-group">
                  <!-- Nome -->
                  <d-form-row>
                    <d-col class="form-group">
                      <label for="feFirstName">Nome</label>
                      <d-form-input required type="text" id="feFirstName" placeholder="Nome" v-model="model.user.name" :state="checkValidateCss(model.user.name)"/>
                      <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
                    </d-col>
                  </d-form-row>
                  <!-- E-mail -->
                  <d-form-row>
                    <d-col class="form-group">
                      <label for="feEmail">E-mail</label>
                      <d-form-input required type="email" id="feEmail" placeholder="E-mail" v-model="model.user.email" :state="checkValidateCss(model.user.email)"/>
                      <d-form-invalid-feedback>E-mail é obrigatório</d-form-invalid-feedback>
                    </d-col>
                  </d-form-row>
                  <!-- Phone -->
                  <d-form-row>
                    <d-col class="form-group">
                      <label for="fePhone">Telefone</label>
                      <input-phone  one id="fePhone" placeholder="Telefone" :model.sync="model.phone" ></input-phone>
                    </d-col>
                  </d-form-row>
                </d-col>
              </d-row>
            </d-form>
            <d-row>
              <d-col cols="12">
                <div class="control__button">
                  <d-button @click="save" class="btn-primary">Salvar</d-button>
                  <loader v-if="loading" :fullPage="false" class="ml-4"/>
                </div>
              </d-col>
            </d-row>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
    <commercial-imports/>
  </d-card>
</template>


<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import InputPhone from '_shared/InputPhone.vue';
import CommercialService from '_services/rest/modules/commercial';
import CommercialButtons from './CommercialButtons.vue';
import CommercialImports from './CommercialImports.vue';
import { MODEL, _LOAD_MODEL_ } from './CommercialModel';

export default {
  name: 'commercial-form',
  components: {
    InputPhone,
    CommercialButtons,
    CommercialImports,
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      loading: false,
      sendPassword: true,
      errros: {},
    };
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'checkAdmin',
    ]),
    checkValidateCss(value) {
      if (!this.submitted) {
        return null;
      }
      if (value != null) {
        return 'valid';
      }
      return 'invalid';
    },
    save() {
      this.toggleLoading();
      CommercialService.save(this.model)
        .then(response => {
          this.success(response);
        })
        .catch(error => {
          this.toggleLoading();
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    success() {
      this.toggleLoading();
      this.activeAlert({ message: 'Perfil salvo com sucesso', theme: 'success' });
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover{
    color: $green;
  }
  &.fa-minus:hover{
    color: $red
  }
  &.fa-save:hover{
    color: $blue;
  }
}
</style>
